const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BoatLeadService = {
  async sendLeadEmailVerification(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/boat-lead/send-email-verification/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error sending verification email.');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async verifyConfirmationCode(email, confirmationCode) {
    try {
      const response = await fetch(`${API_BASE_URL}/boat-lead/verify-code/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, confirmation_code: confirmationCode }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Invalid confirmation code. Please try again.');
      }

      return data;
    } catch (error) {
      throw error;
    }
  },

  async createLead(leadData) {
    try {
      const response = await fetch(`${API_BASE_URL}/leads/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(leadData),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Failed to create lead. Please try again.');
      }
      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default BoatLeadService;